import { Component, Input, OnInit } from '@angular/core';
import { NewFeatureAlertInterface } from './new-feature-alert.interface';
import { AuthComponent } from '@app/modules/auth/auth.component';
import { ConfigurationService, EventsService, NgxToastrService } from '@app/_shared/providers';
import { PersonalDetailsService } from '@app/modules/trading/modules/profile/providers/personal-details/personal-details.service';
import { CustomEvents, LOCAL_STORAGE_KEYS, NEW_FEATURES_ALERT_CACHE_KEY, StorageHelper } from '@app/_helpers';
import { HttpClient } from '@angular/common/http';
import { UserManagementService } from '@app/modules/admin/providers/user-management/user-management.service';
import { AuthService } from '@app/modules/auth';

interface CacheResponse {
  data?: any;
  error?: boolean;
  message?: string;
}

@Component({
  selector: 'app-new-feature-alert',
  templateUrl: './new-feature-alert.component.html',
  styleUrls: ['./new-feature-alert.component.scss']
})
export class NewFeatureAlertComponent implements OnInit {

  isClosed: boolean = false;

  newFeatureAlert: NewFeatureAlertInterface;

  cacheRequestKey: string = NEW_FEATURES_ALERT_CACHE_KEY;

  constructor(private userService: UserManagementService,
    private configService: ConfigurationService,
    private toast: NgxToastrService,
    private authService: AuthService,
    private eventsService: EventsService) { }

  ngOnInit(): void {
    this.newFeatureAlert = this.configService.remoteConfigCacheObj.NEW_FEATURES_ALERT;
    if (this.newFeatureAlert) {
      if (this.newFeatureAlert.showOnceOnLogin) {
        // get the value from local storage that user has interacted before or not.
        if (StorageHelper.hasKey(LOCAL_STORAGE_KEYS.IS_NEW_FEATURE_ALERT_CLOSED)) {
          this.isClosed = StorageHelper.isNewFeatureAlertClosed;
        }
        else {
          this.setCloseLocal(false);
        }
      }
      else {
        // get the value from backend that user has interacted before or not.
        this.getValueFromCache();
      }
    } else {
      this.isClosed = true;
    }
    this.authService.isNewFeatureAlert = !this.isClosed;
  }

  close() {
    if (!this.newFeatureAlert.showOnceOnLogin) {
      // set the value in backend that user has closed the popup.
      this.setValueInCache();
    }
    else {
      //set value in local storage tthat user has closed the popup.
      this.setCloseLocal(true);
    }
    this.authService.isNewFeatureAlert = false;
    this.eventsService.publish(CustomEvents.bannerClosed);
  }

  setValueInCache() {
    this.userService.setCache(this.cacheRequestKey, this.newFeatureAlert.id).subscribe({
      next: (response: CacheResponse) => {
        if (response.hasOwnProperty('error') && !response.error) {
          this.isClosed = true;
        } else {
          this.toast.simpleCustomToaster(response.message);
        }
        this.authService.isNewFeatureAlert = !this.isClosed;
      },
      error: () => {
        this.isClosed = true;
        this.authService.isNewFeatureAlert = !this.isClosed;
      }
    });
  }

  getValueFromCache() {
    this.userService.getCache(this.cacheRequestKey).subscribe({
      next: (response: CacheResponse) => {
        if (response.hasOwnProperty('error') && !response.error) {
          this.isClosed = response.data == this.newFeatureAlert.id;
        } else {
          this.toast.simpleCustomToaster(response.message);
        }
        this.authService.isNewFeatureAlert = !this.isClosed;
      },
      error: () => {
        this.isClosed = true;
        this.authService.isNewFeatureAlert = !this.isClosed;
      }
    });
  }

  setCloseLocal(value: boolean) {
    this.isClosed = value;
    StorageHelper.isNewFeatureAlertClosed = value;
    this.authService.isNewFeatureAlert = !this.isClosed;
  }

  openLink() {
    window.open(this.newFeatureAlert.link);
  }
}
